import { render, staticRenderFns } from "./ShopCartV2.vue?vue&type=template&id=4e4ea73e&scoped=true&"
import script from "./ShopCartV2.vue?vue&type=script&lang=js&"
export * from "./ShopCartV2.vue?vue&type=script&lang=js&"
import style0 from "./ShopCartV2.vue?vue&type=style&index=0&id=4e4ea73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ea73e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4e4ea73e', component.options)
    } else {
      api.reload('4e4ea73e', component.options)
    }
    module.hot.accept("./ShopCartV2.vue?vue&type=template&id=4e4ea73e&scoped=true&", function () {
      api.rerender('4e4ea73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cart/ShopCartV2.vue"
export default component.exports